<template>
  <div
    class="featured-projects grid-accordion"
    v-if="groupDisplay?.length"
    :style="{ '--grid-cols-vl': gridColumns }"
  >
    <div class="row -top">
      <div class="grid">
        <ProjectTeaser
          :class="{ '-in-transition': projectInTransition === p.id, '-short': gridColumns === 2 }"
          class="teaser link teaser-default"
          v-for="(p, index) in groupDisplay"
          :key="p.id"
          :project="p"
          :style="{ '--transition-delay': `${(index % gridColumns) * 200 + 150}ms` }"
          @click="setInTransition(p.id)"
        />
      </div>
    </div>
    <div
      class="row -hidden"
      id="featured-projects"
      v-if="groupHidden?.length"
      :class="{ '-visible': isGroupHiddenVisible }"
    >
      <div
        class="grid"
        ref="hiddenGridElement"
        :style="{ 'max-height': isGroupHiddenVisible ? `${maxHeight}px` : 0 }"
      >
        <ProjectTeaser
          :class="{ '-in-transition': projectInTransition === p.id, '-short': gridColumns === 2 }"
          class="teaser teaser-default"
          v-for="(p, index) in groupHidden"
          :key="p.id"
          :project="p"
          :style="{ '--transition-delay': `${(index % gridColumns) * 200 + 150}ms` }"
          @click="setInTransition(p.id)"
        />
      </div>
      <button
        @click="isGroupHiddenVisible = !isGroupHiddenVisible"
        type="button"
        class="toggle button-primary -dark"
        aria-controls="featured-projects"
        aria-label="Open featured projects"
      >
        {{ isGroupHiddenVisible ? close : open }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import ProjectTeaser from '~/components/content-modules/components/ProjectTeaser.vue';
import type { ProjectFragment } from '#gql';
import type { GeneralFragment } from '#gql';
import type { ComputedRef } from 'vue';

const props = defineProps<{
  projects: ProjectFragment[];
}>();

const projectInTransition = ref<null | string>(null);
const groupDisplay = ref<ProjectFragment[]>([]);
const groupHidden = ref<ProjectFragment[]>([]);
const isGroupHiddenVisible = ref<boolean>(false);
const maxHeight = ref<number>(0);
const hiddenGridElement = ref<HTMLElement | null>(null);

const gridColumns = computed(function () {
  if (props.projects.length === 2 || props.projects.length === 4) {
    return 2;
  }
  return 3;
});

const general = inject<ComputedRef<GeneralFragment | null>>('general');

const close = computed(function () {
  return general?.value?.projectToggleShowLess ?? '';
});

const open = computed(function () {
  return general?.value?.projectToggleShowAll ?? '';
});

watch(hiddenGridElement, function () {
  setMaxHeight();

  window.addEventListener('resize', setMaxHeight);
});

watchEffect(function () {
  if (props.projects.length === 8) {
    groupDisplay.value = props.projects.slice(0, 8);
    groupHidden.value = props.projects.slice(8);
  } else if (props.projects?.length) {
    groupDisplay.value = props.projects.slice(0, 12);
    groupHidden.value = props.projects.slice(12);
  }
});

function setInTransition(pId: string) {
  // projectInTransition.value = pId;
}

function setMaxHeight() {
  if (hiddenGridElement.value) {
    maxHeight.value = hiddenGridElement.value.scrollHeight;
  }
}
</script>

<style scoped lang="scss">
.featured-projects {
  --grid-cols-vl: 3;

  @media (--vs) {
    padding: var(--base-component-padding-block) var(--base-component-padding-inline);
  }

  @media (--vl) {
    padding: 8.5rem var(--base-component-padding-inline);
  }
}
</style>
